module.exports = {
  API_ROOT: 'https://hc-agency.pre.next-insur.tech',
  PAY_KEY: 'pk_test_7eDxh1QLcQpFFUpSepTONJd800hGFerWpe',
  ACTIVE_TIME: 10800,  // 活躍時間 s
}
